import { z } from 'zod'
import { HEADER_KEYS } from '@reward-platform/shared-api/headers'
import { ValidationError } from '~/utils/errors'
import { ApiRequestHeaders } from './types'

type ServiceSchema = z.ZodType<Record<string, unknown> | Record<string, unknown>[] | undefined>

export const createServiceSchemaValidator =
  <T extends ServiceSchema>(schema: T) =>
  (data: unknown, message?: string): z.infer<T> => {
    const safeParse = schema.safeParse(data)
    if (!safeParse.success) {
      const error = new ValidationError(safeParse.error, message)
      error.logToDatadog()
      throw error
    }
    return safeParse.data
  }

export const createServiceSchemaValidatorAsync =
  <T extends ServiceSchema>(schema: T) =>
  async (data: unknown, message?: string): Promise<z.infer<T>> => {
    const safeParse = await schema.safeParseAsync(data)
    if (!safeParse.success) {
      const error = new ValidationError(safeParse.error, message)
      error.logToDatadog()
      throw error
    }
    return safeParse.data
  }

export const getDefaultApiClientOptions = (params: ApiRequestHeaders) => {
  const { opCo, countryCode, currencyCode, locale } = params

  return {
    headers: {
      [HEADER_KEYS.countryCode]: countryCode,
      [HEADER_KEYS.currencyCode]: currencyCode,
      [HEADER_KEYS.partnerCode]: opCo,
      [HEADER_KEYS.languageCode]: locale,
    },
  }
}
